export default "__VITE_ASSET__Bn72eYsP__"